import React from 'react'
import { useAppState } from 'Context/AppContext/AppContext'
import { useQuery } from '@apollo/client'
import GET_STORIES_BULK from 'Apollo/Queries/GetStoriesBulk'
import { InfoIcon, colors } from '@resiliatech/birdsong'
import { Tooltip, IconButton } from '@mui/material'
import { Story } from 'Generated/graphql-types'
import { StoriesMetricsContainer } from './StoriesMetrics.styled'
import { WithWidgetLoading } from '../WithWidgetLoading'
import { Header } from '../ImpactReportDashboard.styled'
import { MetricsCard } from '../MetricsCard/MetricsCard'
import { MetricsCardContainer } from '../MetricsCard/MetricsCard.styled'

export const StoriesMetrics = () => {
  const appState = useAppState()
  const {
    nonprofitOrgConfig: { orgId: nonprofitOrgId },
  } = appState

  const { data, loading } = useQuery(GET_STORIES_BULK, {
    variables: { nonprofitOrgId },
    skip: !nonprofitOrgId,
  })

  const stories: Story[] = data?.getStories || []

  const metrics = {
    avgClickThroughRate: Math.round(
      (stories.reduce((sum, story) => sum + (story.ctaClickCount ?? 0), 0) /
        Math.max(
          1,
          stories.reduce((sum, story) => sum + (story.viewCount ?? 0), 0)
        )) *
        100
    ),
    totalViews: stories.reduce((sum, story) => sum + (story.viewCount ?? 0), 0),
    totalClicks: stories.reduce(
      (sum, story) => sum + (story.ctaClickCount ?? 0),
      0
    ),
    totalPublished: stories.length,
  }

  const metricDetails = [
    {
      title: 'Avg Click Through Rate',
      value: `${metrics.avgClickThroughRate}%`,
      tooltip:
        'The Average Click Through Rate is calculated across all Views and Clicks for published stories with a Call To Action button.',
    },
    { title: 'Total Views', value: metrics.totalViews },
    { title: 'Total Clicks', value: metrics.totalClicks },
    { title: 'Total Published', value: metrics.totalPublished },
  ]

  return (
    <WithWidgetLoading loading={loading} width='100%' height='auto'>
      <StoriesMetricsContainer>
        <Header>Stories</Header>
        <MetricsCardContainer>
          {metricDetails.map((metric) => (
            <MetricsCard
              key={metric.title}
              title={
                <>
                  {metric.title}
                  {metric.tooltip && (
                    <Tooltip title={metric.tooltip} arrow>
                      <IconButton size='small' sx={{ ml: 1 }}>
                        <InfoIcon
                          variant='outlined'
                          size='small'
                          color={colors.background.dialogBackground}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              }
              value={metric.value}
            />
          ))}
        </MetricsCardContainer>
      </StoriesMetricsContainer>
    </WithWidgetLoading>
  )
}
